module.exports = __webpack_public_path__ + "static/media/content_outline.cd768b0e.png";